import React from 'react'
import { FaFacebookF, FaInstagram } from 'react-icons/fa'
import styled from 'styled-components'
import { FontSize2, NolKoma7toNolKoma8 } from '../../GlobalStyles'

const FooterContainer = styled.footer`
    background-color: black;
    color: white;
    margin-top: 3rem;
`
const FooterWrapper = styled.div`
    width: 90%;
    max-width: 1400px;
    margin: 0 auto;
    padding: 2rem 0;
    display: grid;
    gap: 3rem;
    /* border: 1px solid white; */
    @media (min-width: 600px) {
        grid-template-columns: repeat(2, 1fr);
    }
    @media (min-width: 850px) {
        grid-template-columns: repeat(3, 1fr);
    }
    @media (min-width: 1100px) {
        grid-template-columns: repeat(4, 1fr);
    }
    @media (min-width: 1350px) {
        grid-template-columns: repeat(5, 1fr);
    }
`
const Line = styled.div`
    width: 100%;
    height: 1px;
    background-color: white;
    margin-top: 6px;
`
const Item = styled.div`
    display: grid;
    gap: 1rem;
    font-size: ${NolKoma7toNolKoma8};
    height: fit-content;
`
const Wrap = styled.div`
    width: 300px;
    border: 1px solid rgba(255, 255, 255, 0.5);
    display: flex;
    align-items: center;
    input {
        padding: 10px 1rem;
        border: none;
        outline: none;
        background-color: transparent;
        width: 100%;
        color: white;
        &::placeholder {
            color: white;
        }
    }
    button {
        padding: 10px 1rem;
        border: none;
        outline: none;
    }
    
`
const IconWrap = styled.div`
    display: grid;
    grid-auto-flow: column;
    gap: 2rem;
    align-items: center;
    width: fit-content;
    svg {
        font-size: ${FontSize2};
    }
`
const BottomText = styled.div`
    font-size: 0.75rem;
    color: white;
    margin-top: 2rem;
    text-align: center;
    padding: 2rem 1rem;
`   
export default function Footer() {
  return (
    <FooterContainer>
        <FooterWrapper>
            <Item>
                <div>
                    <p>JOIN OUR MAILING LIST</p> 
                    <Line />
                </div>
                <p>Sign up to our newsletter to get more promotions and news update.</p>
                <Wrap>
                    <input type="text" placeholder='E-Mail Address'/>
                    <button>SUBSCRIBE</button>
                </Wrap>
            </Item>
            <Item>
                <div>
                    <p>ABOUT HIJABISTAHUB</p>
                    <Line />
                </div>
                <p>About US</p>
            </Item>
            <Item>
                <div>
                    <p>INFORMATION</p>
                    <Line />
                </div>
                <p>How To Order</p>
                <p>Shipping Details</p>
                <p>Payment</p>
                <p>Track Order</p>
                <p>Pick Up Order</p>
            </Item>
            <Item>
                <div>
                    <p>HELP</p>
                    <Line />
                </div>
                <p>Contact US</p>
                <p>Return And Exchange</p>
                <p>Terms And Conditions</p>
                <p>Privacy Policy</p>
            </Item>
            <Item>
                <div>
                    <p>FOLLOW US</p>
                    <Line />
                </div>
                <IconWrap>
                    <FaFacebookF />
                    <FaInstagram />
                </IconWrap>
            </Item>
        </FooterWrapper>
        <BottomText>
            Copyright © 2022 Hijabistahub. All Rights Reserved. Powered by Arya Adinul Fadlan.
        </BottomText>
    </FooterContainer>
  )
}
